/**
 * Route for `rule-engine-with-if-then-conditional-triggers`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RuleEngineWithIfThenConditionalTriggersPage } from "../features/rule-engine-with-if-then-conditional-triggers/RuleEngineWithIfThenConditionalTriggersPage";

export const ruleEngineWithIfThenConditionalTriggersRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/rule-engine-with-if-then-conditional-triggers",
	component: RuleEngineWithIfThenConditionalTriggersPage,
});

export default ruleEngineWithIfThenConditionalTriggersRoute;
